module.exports = __webpack_public_path__ + "img/navbar-logo.e9c91bd1.svg";